import { FEATURE, FEATURE_PARAMS, DEBUG_FEATURE, areParamsValid, convertParamsToNamed, convertNamedToParams, } from '@wix/deeplink-core';
// DO NOT EXPORT `registeredFeatures`!
// Otherwise, you'll have to deal with stale references after feature re-register
const registeredFeatures = {};
function isValidMapping(mapping) {
    if (!mapping) {
        return false;
    }
    if (!mapping.show) {
        return false;
    }
    if (typeof mapping.show !== 'function') {
        return false;
    }
    if (mapping.check != null && typeof mapping.check !== 'function') {
        return false;
    }
    return true;
}
export class UnknownFeatureError extends Error {
}
export class InvalidMappingError extends Error {
}
function isFeatureType(v) {
    return v in FEATURE;
}
export function register(featuresMap) {
    const unknown = [];
    const invalidMapping = [];
    const okayToRegister = {};
    const featureMapKeys = Object.keys(featuresMap);
    // `Object.keys` doesn't include `Symbol`s
    if (DEBUG_FEATURE in featuresMap) {
        featureMapKeys.push(DEBUG_FEATURE);
    }
    for (const key of featureMapKeys) {
        if (!isFeatureType(key)) {
            unknown.push(key);
            continue;
        }
        const value = featuresMap[key];
        if (!isValidMapping(value)) {
            invalidMapping.push(key);
            continue;
        }
        okayToRegister[key] = value.check
            ? {
                check: value.check,
                show: value.show,
            }
            : { show: value.show };
    }
    if (unknown.length) {
        throw new UnknownFeatureError(`[deeplink] Trying to register unknown features: ${unknown.join(', ')}`);
    }
    if (invalidMapping.length) {
        throw new InvalidMappingError(`[deeplink] Features have invalid methods mapping: ${invalidMapping.join(', ')}`);
    }
    Object.assign(registeredFeatures, okayToRegister);
}
export async function check(feature) {
    if (!feature || !feature.type) {
        throw new Error(`[deeplink] type is required`);
    }
    const type = feature.type;
    let params;
    let named;
    if ('params' in feature && feature.params) {
        params = feature.params.slice(0, FEATURE_PARAMS[type].length);
        named = convertParamsToNamed(type, params);
    }
    else if ('named' in feature && feature.named) {
        named = feature.named;
        params = convertNamedToParams(type, named);
    }
    else {
        throw new Error(`[deeplink] params (either "params" or "named") are required`);
    }
    const registeredCallbacks = registeredFeatures[type];
    if (!registeredCallbacks) {
        return false;
    }
    const f = {
        type,
        params,
        named,
    };
    const registeredCheck = registeredCallbacks.check;
    if (!registeredCheck) {
        return true;
    }
    if (!areParamsValid(f.type, f.params)) {
        return false;
    }
    return !!(await registeredCheck(f));
}
export async function show(feature) {
    if (!feature || !feature.type) {
        throw new Error(`[deeplink] type is required`);
    }
    const type = feature.type;
    let params;
    let named;
    if ('params' in feature && feature.params) {
        params = feature.params.slice(0, FEATURE_PARAMS[type].length);
        named = convertParamsToNamed(type, params);
    }
    else if ('named' in feature && feature.named) {
        named = feature.named;
        params = convertNamedToParams(type, named);
    }
    else {
        throw new Error(`[deeplink] params (either "params" or "named") are required`);
    }
    const registeredCallbacks = registeredFeatures[type];
    if (!registeredCallbacks) {
        return;
    }
    const f = {
        type,
        params,
        named,
    };
    if (!areParamsValid(f.type, f.params)) {
        return;
    }
    const registeredCheck = registeredCallbacks.check;
    const registeredShow = registeredCallbacks.show;
    if (registeredCheck && !(await registeredCheck(f))) {
        return;
    }
    await registeredShow(f);
}
//# sourceMappingURL=index.js.map